import React, { ChangeEvent, FC, PropsWithChildren } from 'react';
import {
  Box,
  MenuItem,
  Pagination,
  PaginationItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';

interface IProps {
  hasPageSizeSelector?: boolean;
  page: number;
  onPageChange: (page: number) => void;
  pageSize: number;
  onPageSizeChange: (pageSize: number) => void;
  count: number;
}

const PAGE_SIZE_OPTIONS = [10, 20, 30, 40, 50];

const PaginationWithPageSize: FC<PropsWithChildren<IProps>> = ({
  hasPageSizeSelector = true,
  page = 1,
  onPageChange,
  pageSize = 10,
  onPageSizeChange,
  count,
}) => {
  return (
    <Box
      alignItems="center"
      display="flex"
      flexDirection="row"
      justifyContent="flex-end"
      width="100%"
    >
      <Box alignItems="center" display="flex" gap={2}>
        {hasPageSizeSelector && (
          <Select
            size="small"
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: '8px',
              },
            }}
            value={pageSize.toString()}
            onChange={(event: SelectChangeEvent) =>
              onPageSizeChange(parseInt(event.target.value, 10))
            }
          >
            {PAGE_SIZE_OPTIONS.map((pageSizeOption) => (
              <MenuItem
                key={`pagination-page-size-${pageSizeOption}`}
                value={pageSizeOption}
              >
                {pageSizeOption}
              </MenuItem>
            ))}
          </Select>
        )}
      </Box>

      <Box display="flex">
        <Pagination
          color="primary"
          count={count}
          page={page}
          renderItem={(item) => (
            <PaginationItem
              slots={{
                previous: () => (
                  <i
                    className="ri-arrow-left-s-line"
                    style={{ fontSize: '16px' }}
                  />
                ),
                next: () => (
                  <i
                    className="ri-arrow-right-s-line"
                    style={{ fontSize: '16px' }}
                  />
                ),
              }}
              sx={{
                '&.MuiPaginationItem-root': {
                  borderRadius: '8px',
                  margin: '0 4px',
                  minWidth: '32px',
                  height: '32px',
                  width: '32px',
                  backgroundColor: 'white',
                  border: '1px solid #E2E8F0',
                  '&:hover': {
                    backgroundColor: '#F8FAFC',
                  },
                },
                '&.MuiPaginationItem-page.Mui-selected': {
                  backgroundColor: '#43505d',
                  color: 'white',
                  border: '1px solid #43505d',
                  '&:hover': {
                    backgroundColor: '#323c46',
                  },
                },
                '&.MuiPaginationItem-previousNext': {
                  backgroundColor: 'white',
                  border: '1px solid #E2E8F0',
                  color: '#64748B',
                  '&:hover': {
                    backgroundColor: '#F8FAFC',
                  },
                },
              }}
              {...item}
            />
          )}
          shape="rounded"
          onChange={(event: ChangeEvent<unknown>, p: number) => onPageChange(p)}
        />
      </Box>
    </Box>
  );
};

export default PaginationWithPageSize;
